import { createPost } from '@eshop/api-client'

import { getSearchCompanyTag } from '#/local/service/searchReport'

const searchReportRental = (itemId: string) => {
    const post = createPost('search')
    const companyTag = getSearchCompanyTag()

    post(`/${companyTag}/rental/add-to-cart?item_id=${itemId}`)
        .catch((error) => {
            console.error('[GlobalListener-SearchReportRental]:', error)
        })
}
export default searchReportRental
